import * as Sentry from "@sentry/react";

class SentryConfig {
    static instance;

    constructor() {
        if (SentryConfig.instance) {
            return SentryConfig.instance;
        }

        SentryConfig.instance = this;
    }

    addSentry() {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 0.1, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/mf\.moamc\.com/, /^https:\/\/www\.motilaloswalmf\.com/, /^https:\/\/beta\.motilaloswalmf\.com/],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }

    logError(error, errorInfo) {
        console.log('error', error);
        console.log('info', errorInfo);
        Sentry.captureException(error, { extra: errorInfo });
    }
}

const sentryInstance = new SentryConfig();
Object.freeze(sentryInstance);

export default sentryInstance;